import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/react';
import axios from "axios";

// Every call sends Accept-Language from localStorage, which is null until a
// visitor picks a language. axios 0.24 sent that as the text "null", so the
// backend answered in English. axios 1 drops the header instead, and the
// backend would then follow the browser's own language — Arabic content under
// an English page for many visitors in Kuwait. Keep sending "null".
axios.interceptors.request.use((config) => {
  if (config.headers["Accept-Language"] === null) {
    config.headers["Accept-Language"] = "null";
  }
  return config;
});

// The live site must not print booking, payment and customer details to the
// browser console. Errors and warnings still show (and reach Sentry).
if (import.meta.env.PROD) {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}

Sentry.init({
  dsn: 'https://c2195cc4a145700d66d6447f8891e061@o4505550110654464.ingest.sentry.io/4505634369961984',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0, // Set the sample rate for tracing (optional, 1.0 means 100%)
});

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
